var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 22,
    height: 22,
    fill: "#D5DAE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9999 10.5417C13.5312 10.5417 15.5832 8.48964 15.5832 5.95833C15.5832 3.42703 13.5312 1.375 10.9999 1.375C8.46858 1.375 6.41655 3.42703 6.41655 5.95833C6.41655 8.48964 8.46858 10.5417 10.9999 10.5417ZM10.9998 20.625C14.314 20.625 17.3543 19.4525 19.7286 17.4996C18.5429 13.9947 15.0832 11.4583 10.9998 11.4583C6.9165 11.4583 3.45674 13.9947 2.27108 17.4996C4.64533 19.4525 7.68566 20.625 10.9998 20.625Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3b86df217d388f6401d054db632759e8.svg";
export { ForwardRef as ReactComponent };